module.exports = __webpack_public_path__ + "static/img/time-icon.5d9a46ed.svg";